import { render } from "./Dashboard.vue?vue&type=template&id=06eec738&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=06eec738&scoped=true&lang=scss"

import exportComponent from "/Users/lgorden/git/Fybr/parking-manager-sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eec738"]])

export default __exports__